import {Box} from "@mui/material"
import {useDispatch, useSelector} from "react-redux"
import {selectCurrentPanelView} from "../../../reducers/notificationsSlice"
import {
	getCurrentScrollPosition,
	selectCurrentViewKey,
	setNotificationScrollPosition
} from "../../../reducers/NotificationScrollControlSlice"
import {DYNAMIC_PANEL_TAB_INDEX_MAP, selectDynamicView} from "../../../reducers/dynamicViewSlice"
import {selectArticles} from "../../../reducers/notificationPanelArticlesSlice"
import {useTabPanelScrollEl} from "../../panels/TabPanel"
import {useScrollPersistence} from "../../../utils/usePersistScrollPosition"
import {useWorkspaceContext} from "../../../pages/Dashboard"


export default function NotificationsScrollControlPanel(props) {
	const dispatch = useDispatch()
	const { workspaceId } = useWorkspaceContext()
	const displayingNotificationsPanel = useSelector((state) => selectDynamicView(state, workspaceId)) === DYNAMIC_PANEL_TAB_INDEX_MAP.NOTIFICATION
	const currentViewKey = useSelector((state) => selectCurrentViewKey(state, workspaceId))
	const articles = useSelector((state) => selectArticles(state, workspaceId))
	const currentPanelViewIndex = useSelector((state) => selectCurrentPanelView(state, workspaceId))
	const scrollRef = useTabPanelScrollEl()
	const currentPosition = useSelector((state) => getCurrentScrollPosition(state, workspaceId))

	useScrollPersistence(scrollRef.current, {
		savedPosition: currentPosition,
		setPosition: (ratio) => dispatch(setNotificationScrollPosition({ratio, workspaceId})),
		isActive: displayingNotificationsPanel,
		restoreDeps: [currentPanelViewIndex, displayingNotificationsPanel, articles],
		restoreConditional: (![null, undefined].includes(currentViewKey) && displayingNotificationsPanel && articles.length <= 0)
	})

	return (
		<Box className="OVERFLOW-NOTI">
			{props.children}
		</Box>
	)
}